import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ShipmentDetailMagento } from '../../models';
import { TmsWebBaseService } from '../base';

@Injectable({
  providedIn: 'root',
})
export class ShipmentDetailMagentoService extends TmsWebBaseService {
  constructor() {
    super('ShipmentDetailMagento');
  }

  importShipmentDetails(): Observable<ShipmentDetailMagento[]> {
    return this.httpService.post<ShipmentDetailMagento[]>(`${this.apiUrl}/ImportShipmentDetails`, {});
  }
}
